import { Plugin, PluginKey } from "prosemirror-state";
import { customSchema } from "../../schemas/custom-schema";

export const notesIdsGeneration = new Plugin({
  appendTransaction: (transactions, oldState, newState) => {
    if(!transactions.some(tr => tr.docChanged)) {
      return null;
    }

    let modified = false;
    const notesLists = [],
      notes = [],
      { tr } = newState;

    newState.doc.descendants((node, pos) => {
      if(node.type.name === "notesList") {
        notesLists.push({ node, pos });
      } else if(node.type.name === "note") {
        notes.push({ node, pos });
      }
    });

    notesLists.forEach(notesList => {
      const { node, pos } = notesList,
        { type } = node.attrs;
      let currentPosition = 1,
        currentDocPosition = pos + 1;
      node.forEach((note, offset) => {
        if(note.type.name === "listItem") {
          tr.setNodeMarkup(currentDocPosition, null, { id: "nota-" + type + "-" + currentPosition });
          currentPosition++;
        }

        currentDocPosition += note.nodeSize;
      });
    });

    let currentNote = 1;
    notes.forEach(({ node, pos }) => {
      const { type } = node.attrs;
      tr.setNodeMarkup(pos, null, { index: currentNote, type, href: "#nota-" + type + "-" + currentNote });
      currentNote++;
    })

    return tr;

    /*transactions.forEach(transaction => {
      transaction.steps.forEach((step, index) => {
        const mapping = transaction.mapping.slice(index);
        step.getMap().forEach((oldStart, oldEnd, newStart, newEnd) => {
          if(newStart === newEnd) {
            return;
          }

          try {
            newState.doc.descendants((node, pos) => {
              if(node.type.name === "notesList") {
                notesLists.push(node);
              }
            });

            notesLists.forEach(notesList => {
              const { type } = notesList.attrs;
              let currentPosition = 1;
              notesList.forEach((note, offset) => {
                note.attrs.id = "nota-" + type + "-" + currentPosition;
                currentPosition++;
              });
            });
          } catch(_) {
            return;
          }
        });
      });
    });*/

    //return modified ? tr : null;
  }
});
